<template>
  <div class="resultados div-conteudo">

    <transition name="modal" v-if="carregando">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <img src="../../assets/imagens/loadingSpinner.gif" alt="Roda de carregamento girando">
            <label>Aguarde. Carregando.</label>
          </div>
        </div>
      </div>
    </transition>

    <div class="fora" v-else>
      <div class="index centro">
        
        <MsgErroFormularios v-if="erro && msgErros" :mensagens="msgErros" />

        <div class="topo-index">
          <h1>Formulários</h1>
          </div>

        <div class="n-div">
          <div class="nresultados" v-show="!carregando">
<label>Total de Resultados: {{ formularios ? formularios.length : 0 }}</label>
          </div>
          </div>

        <table v-if="formularios && formularios.length > 0" class="container-tabela">
          <thead>
            <tr>
              <th>Título do Formulário</th>
              <th>Unidade Organizacional</th>
              <th>Data de Abertura</th>
              <th>Data de Encerramento</th>
              <th>Status</th>
              <th class="coluna-acoes">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="formulario in formularios" :key="formulario.id" :class="getStatusInfo(formulario).classe">
              <td data-label="Título:">{{ formulario.titulo }}</td>
              
              <td data-label="Unidade:">
                <span v-if="formulario.unidade">
                  {{ formulario.unidade.nome }}
                  <span v-if="formulario.unidade.sigla">({{ formulario.unidade.sigla }})</span>
                </span>
                <span v-else>
                  {{ formulario.id_unidade }}
                </span>
              </td>
              
              <td data-label="Abertura:">{{ formatarData(formulario.data_inicio) }}</td>
              <td data-label="Encerramento:">{{ formatarData(formulario.data_final) }}</td>
              <td data-label="Status:">
                <span :class="getStatusInfo(formulario).classeSpan">{{ getStatusInfo(formulario).texto }}</span>
              </td>
              <td class="coluna-acoes">
                <router-link :to="{ name: 'FormularioShow', params: { id: formulario.id } }" class="icone-tabela">
                  <img src="../../assets/imagens/icon-view.svg" alt="Visualizar" title="Visualizar" />
                </router-link>
                <router-link :to="{ name: 'FormularioResponder', params: { id: formulario.id } }" class="icone-tabela">
                  <img src="../../assets/imagens/linhas-caneta-escuro.svg" alt="Responder" title="Responder Formulário" />
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
        
        <p v-else><b class="sem-resultados">Nenhum formulário encontrado</b></p>

      </div>
    </div>
  </div>
</template>

<script>
import { parseISO, format } from "date-fns";
import metaDados from "../../helpers/metaDados";
import HomeApi from "../../services/HomeApi";
import MsgErroFormularios from "../../components/MsgErroFormularios.vue";

export default {
  name: 'Home',
  metaInfo() {
      return {
          title: "Home",
          titleTemplate: "%s - Casa Civil do Estado de Goiás",
          meta: [
              {
                  vmid: "og:title",
                  property: "og:title",
                  content: "Home - Casa Civil do Estado de Goiás",
              },
              ...metaDados(this.$route),
          ],
      };
  },
  components: {
    MsgErroFormularios,
  },
  
  data() {
    return {
      formularios: [],
      carregando: true,
      erro: false,
      msgErros: {
        default: '',
      },      
    };
  },
  
  created() {
    this.homeApi = new HomeApi();
    this.carregarFormularios();
  },
  
  methods: {
    
    async carregarFormularios() {
      this.carregando = true;
      this.erro = false;
      try {
        this.formularios = await this.homeApi.getFormulariosHome();
      } catch (err) {
        console.error("Erro ao carregar formulários da home:", err);
        this.erro = true;
        this.msgErros.default = "Erro ao carregar formulários.";
      } finally {
        this.carregando = false;
      }
    },
    
    formatarData: function (value) {
      if (!value) return '';
      return format(parseISO(value), "dd/MM/yyyy");
    },
    
    getStatusInfo(formulario) {
      const hoje = new Date();
      const dataFinal = parseISO(formulario.data_final);
      hoje.setHours(0, 0, 0, 0);

      const diffTime = dataFinal.getTime() - hoje.getTime();
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (diffDays >= 0 && diffDays <= 2) {
        return { texto: "Encerramento iminente", classe: "status-linha-vermelho", classeSpan: "status-finalizada" };
      }
      if (diffDays >= 0 && diffDays <= 3) {
        return { texto: "Encerramento próximo", classe: "status-linha-amarelo", classeSpan: "status-em-andamento" };
      }
      return { texto: "Aberto", classe: "status-linha-verde", classeSpan: "status-aberta" };
    },
  },  
};
</script>

<style lang="scss" scoped>
  .status-aberta {
    color: #28a745;
    font-weight: bold;
  }
  .status-em-andamento {
    color: #e4c30b;
    font-weight: bold;
  }
  .status-finalizada {
    color: #bd0000;
    font-weight: bold;
  }

  ::v-deep tr.status-linha-verde {
  } 
  .coluna-acoes {
    text-align: center;
  }
</style>